// Package imports:
import React, { useEffect, useState } from 'react';
// Component imports:
import ColoredNumber from '../../ui-elements/ColoredNumber/ColoredNumber';
import Link from '../../ui-elements/Link/Link';
import TandemTable from '../../ui-elements/Table/TandemTable';
import Alert from '../../ui-elements/Alert/Alert';
import Loading from '../../ui-elements/Loading/Loading';
import DisplayBox from '../DisplayBox/DisplayBox';
// Service imports:
import { formatNumber, convertToPercentage, getTableDate, getLastDayOfLastMonth } from '../../services/utils';
import { useApiLmdData } from '../../services/apiHooks';
// Type imports:
import { IDefaultProps } from '../../types/Types';
import { IApiLmdFundPrice } from '../../types/FundsTypes';

interface IOwnProps {
    basecurrency?: string
}
type Props = IDefaultProps & IOwnProps & React.HTMLAttributes<HTMLDivElement>;

const SpecialFundsTable: React.FC<Props> = ({
    accessToken,
    refreshRateMs,
    ...props
}) => {

    const [ data ] = useApiLmdData<IApiLmdFundPrice[]>(
        `/v1/market_data/v1/specialfunds/keldan/by_date?date=${getLastDayOfLastMonth()}`,
        accessToken,
        refreshRateMs
    );
    const [dataFrjalsi, setDataFrjalsi ] = useState<IApiLmdFundPrice[]>([]);
    const [dataIsl, setDataIsl ] = useState<IApiLmdFundPrice[]>([]);
    const [dataLif, setDataLif ] = useState<IApiLmdFundPrice[]>([]);

    useEffect(() => {
        if (data.data !== null)
            handleData(data.data);
    }, [data]);

    const handleData = (body: IApiLmdFundPrice[]) => {
        setDataFrjalsi(body.filter(x => x.Symbol?.startsWith('frjalsi')))
        setDataIsl(body.filter(x => x.Symbol?.startsWith('isl')))
        setDataLif(body.filter(x => x.Symbol?.startsWith('lif')))
    }

    return (
        <DisplayBox 
            className='KCL_special-funds-table'
            title="Séreignarsjóðir"
            {...props}
        >
            {
                (data instanceof Error)
                ? <Alert type='error' headText={data.message}/>
                : (data === null)
                ? <Loading />
                : <TandemTable
                    data={[
                        dataIsl,
                        dataFrjalsi,
                        dataLif]}
                    columns={[
                                [
                                    {
                                        title: 'Framtíðarauður Íslandsbanka',
                                        dataAccessor: ( {Name, Symbol} ) => (
                                            <Link 
                                                url={`/Markadir/Sjodir/${Symbol}` ?? ''} 
                                                linkSize='15'
                                                >{Name}</Link>
                                        ),
                                        textAlign: 'left'
                                    },
                                    {
                                        title: 'Gengi',
                                        dataAccessor: ( {LastPrice} ) => (formatNumber(LastPrice, '-', 2)),
                                    },
                                    {
                                        title: 'Dagsetning',
                                        dataAccessor: ( {ValueDate } ) => (ValueDate && getTableDate(ValueDate.toString(), 'DD/MM/YYYY', '.')),
                                        
                                    }, {
                                        title: '1 Ár',
                                        dataAccessor: ( {Change12m} ) => (
                                            <ColoredNumber
                                                hasArrow
                                                sign={(Change12m === null) ? 'neutral' : (Change12m < 0) ? 'neg' : (Change12m > 0) ? 'pos' : 'neutral'}>
                                                    {convertToPercentage(Change12m, true, 2)}
                                            </ColoredNumber>
                                        ),
                                    }, {
                                        title: '2 Ár',
                                        dataAccessor: ( {Change24m} ) => (
                                            <ColoredNumber  
                                                sign={(Change24m === null) ? 'neutral' : (Change24m < 0) ? 'neg' : (Change24m > 0) ? 'pos' : 'neutral'}>
                                                    {convertToPercentage(Change24m, true, 2)}
                                            </ColoredNumber>
                                        ),
                                    }, {
                                        title: '3 Ár',
                                        dataAccessor: ( {Change36m} ) => (
                                            <ColoredNumber
                                                hasArrow
                                                sign={(Change36m === null) ? 'neutral' : (Change36m < 0) ? 'neg' : (Change36m > 0) ? 'pos' : 'neutral'}>
                                                    {convertToPercentage(Change36m, true, 2)}
                                            </ColoredNumber>
                                        ),
                                    }, {
                                        title: '4 Ár',
                                        dataAccessor: ( {Change48m} ) => (
                                            <ColoredNumber
                                                hasArrow
                                                sign={(Change48m === null) ? 'neutral' : (Change48m < 0) ? 'neg' : (Change48m > 0) ? 'pos' : 'neutral'}>
                                                    {convertToPercentage(Change48m, true, 2)}
                                            </ColoredNumber>
                                        ),
                                    }, {
                                        title: '5 Ár',
                                        dataAccessor: ( {Change60m} ) => (
                                            <ColoredNumber
                                                hasArrow
                                                sign={(Change60m === null) ? 'neutral' : (Change60m < 0) ? 'neg' : (Change60m > 0) ? 'pos' : 'neutral'}>
                                                    {convertToPercentage(Change60m, true, 2)}
                                            </ColoredNumber>
                                        ),
                                    }
                                ],
                                [
                                    {
                                        title: 'Frjálsi lífeyrissjóðurinn',
                                        dataAccessor: ( {Name, Symbol} ) => (
                                            <Link url={`/Markadir/Sjodir/${Symbol}` ?? ''} linkSize='15'>{Name}</Link>
                                        ),
                                        textAlign: 'left'
                                    },
                                    {
                                        title: '',
                                        dataAccessor: ( {LastPrice} ) => (formatNumber(LastPrice, '-', 2)),
                                    },
                                    {
                                        title: '',
                                        dataAccessor: ( {ValueDate } ) => (ValueDate && getTableDate(ValueDate.toString(), 'DD/MM/YYYY', '.')),
                                        
                                    }, {
                                        title: '',
                                        dataAccessor: ( {Change12m} ) => (
                                            <ColoredNumber
                                                hasArrow
                                                sign={(Change12m === null) ? 'neutral' : (Change12m < 0) ? 'neg' : (Change12m > 0) ? 'pos' : 'neutral'}>
                                                    {convertToPercentage(Change12m, true, 2)}
                                            </ColoredNumber>
                                        ),
                                    }, {
                                        title: '',
                                        dataAccessor: ( {Change24m} ) => (
                                            <ColoredNumber  
                                                sign={(Change24m === null) ? 'neutral' : (Change24m < 0) ? 'neg' : (Change24m > 0) ? 'pos' : 'neutral'}>
                                                    {convertToPercentage(Change24m, true, 2)}
                                            </ColoredNumber>
                                        ),
                                    }, {
                                        title: '',
                                        dataAccessor: ( {Change36m} ) => (
                                            <ColoredNumber
                                                hasArrow
                                                sign={(Change36m === null) ? 'neutral' : (Change36m < 0) ? 'neg' : (Change36m > 0) ? 'pos' : 'neutral'}>
                                                    {convertToPercentage(Change36m, true, 2)}
                                            </ColoredNumber>
                                        ),
                                    }, {
                                        title: '',
                                        dataAccessor: ( {Change48m} ) => (
                                            <ColoredNumber
                                                hasArrow
                                                sign={(Change48m === null) ? 'neutral' : (Change48m < 0) ? 'neg' : (Change48m > 0) ? 'pos' : 'neutral'}>
                                                    {convertToPercentage(Change48m, true, 2)}
                                            </ColoredNumber>
                                        ),
                                    }, {
                                        title: '',
                                        dataAccessor: ( {Change60m} ) => (
                                            <ColoredNumber
                                                hasArrow
                                                sign={(Change60m === null) ? 'neutral' : (Change60m < 0) ? 'neg' : (Change60m > 0) ? 'pos' : 'neutral'}>
                                                    {convertToPercentage(Change60m, true, 2)}
                                            </ColoredNumber>
                                        ),
                                    }
                                ],
                                [
                                    {
                                        title: 'Íslenski lífeyrissjóðurinn',
                                        dataAccessor: ( {Name, Symbol} ) => (
                                            <Link url={`/Markadir/Sjodir/${Symbol}` ?? ''} linkSize='15'>{Name}</Link>
                                        ),
                                        textAlign: 'left'
                                    },
                                    {
                                        title: '',
                                        dataAccessor: ( {LastPrice} ) => (formatNumber(LastPrice, '-', 2)),
                                    },
                                    {
                                        title: '',
                                        dataAccessor: ( {ValueDate } ) => (ValueDate && getTableDate(ValueDate.toString(), 'DD/MM/YYYY', '.')),
                                        
                                    }, {
                                        title: '',
                                        dataAccessor: ( {Change12m} ) => (
                                            <ColoredNumber
                                                hasArrow
                                                sign={(Change12m === null) ? 'neutral' : (Change12m < 0) ? 'neg' : (Change12m > 0) ? 'pos' : 'neutral'}>
                                                    {convertToPercentage(Change12m, true, 2)}
                                            </ColoredNumber>
                                        ),
                                    }, {
                                        title: '',
                                        dataAccessor: ( {Change24m} ) => (
                                            <ColoredNumber  
                                                sign={(Change24m === null) ? 'neutral' : (Change24m < 0) ? 'neg' : (Change24m > 0) ? 'pos' : 'neutral'}>
                                                    {convertToPercentage(Change24m, true, 2)}
                                            </ColoredNumber>
                                        ),
                                    }, {
                                        title: '',
                                        dataAccessor: ( {Change36m} ) => (
                                            <ColoredNumber
                                                hasArrow
                                                sign={(Change36m === null) ? 'neutral' : (Change36m < 0) ? 'neg' : (Change36m > 0) ? 'pos' : 'neutral'}>
                                                    {convertToPercentage(Change36m, true, 2)}
                                            </ColoredNumber>
                                        ),
                                    }, {
                                        title: '',
                                        dataAccessor: ( {Change48m} ) => (
                                            <ColoredNumber
                                                hasArrow
                                                sign={(Change48m === null) ? 'neutral' : (Change48m < 0) ? 'neg' : (Change48m > 0) ? 'pos' : 'neutral'}>
                                                    {convertToPercentage(Change48m, true, 2)}
                                            </ColoredNumber>
                                        ),
                                    }, {
                                        title: '',
                                        dataAccessor: ( {Change60m} ) => (
                                            <ColoredNumber
                                                hasArrow
                                                sign={(Change60m === null) ? 'neutral' : (Change60m < 0) ? 'neg' : (Change60m > 0) ? 'pos' : 'neutral'}>
                                                    {convertToPercentage(Change60m, true, 2)}
                                            </ColoredNumber>
                                        ),
                                    }
                                ],

                            ]}
                            tableSize="lg"
                        />
            }
        </DisplayBox>
    );
}

export default SpecialFundsTable;